export default "__VITE_ASSET__BuhI0IA___"